import React from 'react'

import MenuSection from '../MenuSection'
import UserSearch from '../UserSearch'

import { TASK_OPTIONS, TASKS_FOR_USER } from '../../helpers/parse'
import { useTaskFilters } from '@SonarCX/providers/TaskFiltersProvider'
import { useEnvironment } from '@SonarCX/providers/EnvironmentProvider'

type AssigneeFilterProps = {
  checkFilters?: boolean
  menuMode?: boolean
  closeModal?: () => void
}

const AssigneeFilter: React.FC<AssigneeFilterProps> = props => {
  const { state, handleChange } = useTaskFilters()
  const { user } = useEnvironment()

  return (
    <MenuSection
      title='Assignees'
      options={TASK_OPTIONS}
      value={state.taskValue}
      setValue={handleChange('taskValue')}
      unassignedOpt='All Assignees'
      {...props}
    >
      {state.taskValue === TASKS_FOR_USER && (
        <UserSearch
          showTeams
          extraEmbeds={['teams']}
          userID={user?.id}
          value={state.taskID}
          setValue={handleChange('taskID')}
          startOpen
        />
      )}
    </MenuSection>
  )
}

export default AssigneeFilter
